const PREPARING_MEDIA_PATTERN =
    /file size|wallet balance|blob|download|temporary storage|credentials|ordinal address/i
const WRITING_ONCHAIN_PATTERN =
    /transaction|broadcast|treechat fee|signature|previous mint|on-chain/i
const CONFIRMING_PATTERN = /database records|cach|cleanup|ordinal minted|completion/i

export function ordinalMintToastKind(answerId?: string | null): string {
    return `mint-${answerId || 'ordinal'}`
}

export function ordinalMintPhaseLabel(message?: string | null): string {
    if (!message) return 'Minting'
    if (CONFIRMING_PATTERN.test(message)) return 'Confirming inscription'
    if (WRITING_ONCHAIN_PATTERN.test(message)) return 'Writing onchain'
    if (PREPARING_MEDIA_PATTERN.test(message)) return 'Preparing media'
    return 'Minting'
}
